import { render } from "./setup.vue?vue&type=template&id=427bfda0"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"

import "./setup.vue?vue&type=style&index=0&id=427bfda0&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/nosecape-leaderboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__